import React from "react";
import { Routes, Route } from "react-router-dom";

import Main from "./components/Main";
import RequireAuth from "./components/RequireAuth";
import FeaturesSection from "./pages/FeaturesSection";
import HowItWorks from "./pages/HowItWorks";
import AboutSection from "./pages/AboutSection";
import Footer from "./components/Footer";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import RegisterPhonePage from "./pages/RegisterPhonePage";
import VerifyPhonePage from "./pages/VerifyPhonePage";
import CompleteRegisterPage from "./pages/CompleteRegisterPage";
import ProfilePage from "./pages/ProfilePage";
import CreateTestPage from "./pages/CreateTestPage";
import GeneratedTestView from "./pages/GeneratedTestView";
import MyTestsPage from "./pages/MyTestsPage";
import TestDetailPage from "./pages/TestDetailPage";
import DashboardLayout from "./components/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import TeacherLivePage from "./pages/TeacherLivePage";
import StudentPlayPage from "./pages/StudentPlayPage";
import TextbookCreate from "./pages/TextbookCreate";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/admin/textbooks/new" element={<TextbookCreate />} />
        <Route path="/features" element={<FeaturesSection />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/about" element={<AboutSection />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* AUTH ROUTES */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register-phone" element={<RegisterPhonePage />} />
        <Route path="/verify" element={<VerifyPhonePage />} />
        <Route path="/complete-register" element={<CompleteRegisterPage />} />

        {/* PROFILE */}
        <Route path="/profile" element={<ProfilePage />} />

        {/* TEST ROUTES */}
        <Route path="/createTest" element={<CreateTestPage />} />
        <Route path="/generated-test" element={<GeneratedTestView />} />
        <Route path="/tests" element={<MyTestsPage />} />
        <Route path="/tests/:id" element={<TestDetailPage />} />

        <Route
  path="/dashboard"
  element={
    <RequireAuth>
      <DashboardLayout>
        <DashboardHome />
      </DashboardLayout>
    </RequireAuth>
  }
/>

<Route
  path="/dashboard/live"
  element={
    <RequireAuth>
      <DashboardLayout>
        <TeacherLivePage />
      </DashboardLayout>
    </RequireAuth>
  }
/>

<Route
  path="/dashboard/tests"
  element={
    <RequireAuth>
      <DashboardLayout>
        <MyTestsPage />
      </DashboardLayout>
    </RequireAuth>
  }
/>

<Route
  path="/dashboard/create"
  element={
    <RequireAuth>
      <DashboardLayout>
        <CreateTestPage />
      </DashboardLayout>
    </RequireAuth>
  }
/>

<Route
  path="/dashboard/profile"
  element={
    <RequireAuth>
      <DashboardLayout>
        <ProfilePage />
      </DashboardLayout>
    </RequireAuth>
  }
/>

        {/* STUDENT */}
        <Route path="/play" element={<StudentPlayPage />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
